module.exports = __webpack_public_path__ + "static/img/alphabetical_sorting.f4751685.svg";